/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../../utils/redux-utils';

export enum CentralInspectorDashBoardActionType {
    OPEN_CENTRAL_INSPECTOR_DASHBOARD_PAGE = 'Dashboard/ open central inspector dashboard page',
    EXIT_CENTRAL_INSPECTOR_DASHBOARD_PAGE = 'Dashboard/ close central inspector dashboard page',
}

export const openCentralInspectorDashBoardPage = () =>
    createAction(CentralInspectorDashBoardActionType.OPEN_CENTRAL_INSPECTOR_DASHBOARD_PAGE);

export const closeCentralInspectorDashBoardPage = () =>
    createAction(CentralInspectorDashBoardActionType.EXIT_CENTRAL_INSPECTOR_DASHBOARD_PAGE);
